import { render, staticRenderFns } from "./InsightTotal.vue?vue&type=template&id=0bfc23ff"
import script from "./InsightTotal.vue?vue&type=script&lang=js"
export * from "./InsightTotal.vue?vue&type=script&lang=js"
import style0 from "./InsightTotal.vue?vue&type=style&index=0&id=0bfc23ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports